import { render, staticRenderFns } from "./DragSelected.vue?vue&type=template&id=4db42ac8&lang=html&"
import script from "./DragSelected.vue?vue&type=script&lang=js&"
export * from "./DragSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports